import { render, staticRenderFns } from "./Page6.vue?vue&type=template&id=fbcdfb66&scoped=true"
import script from "./Page6.vue?vue&type=script&lang=js"
export * from "./Page6.vue?vue&type=script&lang=js"
import style0 from "./Page6.vue?vue&type=style&index=0&id=fbcdfb66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcdfb66",
  null
  
)

export default component.exports